/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Not_Found_DescriptionInputs */

const en_not_found_description = /** @type {(inputs: Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The page you are looking for does not exist`)
};

const es_not_found_description = /** @type {(inputs: Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La pagina que buscas no existe`)
};

/**
* | output |
* | --- |
* | "The page you are looking for does not exist" |
*
* @param {Not_Found_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const not_found_description = /** @type {((inputs?: Not_Found_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Not_Found_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_not_found_description(inputs)
	return es_not_found_description(inputs)
});